import values from 'lodash/values';
import keyBy from 'lodash/keyBy';
import {
    addDomain,
    deleteDomain,
    fetchDomainVerificationRecords,
    refreshVerification,
    verifyDomain,
} from './domains.utils';
import { useOrganizationStore } from '@/stores/organization.store';

let loadAllPromise;

export default {
    namespaced: true,
    state: {
        map: {},
    },
    mutations: {
        setMap (state, { map }) {
            state.map = map;
        },
        setMapAtKey (state, { id, domain }) {
            state.map[id] = domain;
        },
        deleteMapKey (state, { id }) {
            delete state.map[id];
        },
    },
    actions: {
        async loadAll ({ commit }, { reFetch = false } = {}) {
            if (loadAllPromise && reFetch !== true) {
                await loadAllPromise;

                return;
            }

            try {
                const orgId = useOrganizationStore().getActive.id;
                loadAllPromise = fetchDomainVerificationRecords(orgId);
                const domains = await loadAllPromise;
                commit('setMap', {
                    map: keyBy(domains, 'id'),
                });
            } catch (error) {
                loadAllPromise = null;
                throw error;
            }
        },
        async verifyDomain ({ getters }, { targetUrl } = {}) {
            const existingRecord = getters.list.find((domain) => domain.domainName === targetUrl);
            if (existingRecord?.isActive) return true;

            try {
                const orgId = useOrganizationStore().getActive.id;
                const verified = await verifyDomain(orgId, targetUrl);

                return verified;
            } catch (error) {
                throw error;
            }
        },
        async add ({ commit }, { targetUrl } = {}) {
            try {
                const orgId = useOrganizationStore().getActive.id;
                const domain = await addDomain(orgId, targetUrl);
                commit('setMapAtKey', { id: domain.id, domain });

                return domain;
            } catch (error) {
                throw error;
            }
        },
        async refresh ({ commit }, { domainId } = {}) {
            try {
                const orgId = useOrganizationStore().getActive.id;
                const domain = await refreshVerification(orgId, domainId);
                commit('setMapAtKey', { id: domainId, domain });

                return domain;
            } catch (error) {
                throw error;
            }
        },
        async remove ({ commit }, { domainId } = {}) {
            try {
                const orgId = useOrganizationStore().getActive.id;
                await deleteDomain(orgId, domainId);
                commit('deleteMapKey', { id: domainId });
            } catch (error) {
                throw error;
            }
        },
    },
    getters: {
        list: (state) => values(state.map),
        getById: (state) => (id) => state.map[id],
    },
};
